(function () {
  "use strict";

  angular
    .module("sempraWebapp")
    .factory("AccountManagementViewModel", accountManagementViewModelFactory);

  /** @ngInject */
  function accountManagementViewModelFactory(
    gridUtils,
    $mdMedia,
    userRolesEnum,
    sessionData
  ) {
    function AccountManagementViewModel() {
      this.currentUser = sessionData.getValue('username');
      this.data = [];
      this.totalElements = 0;
      this.groups = [];
      this.limitPerPage = 10;
      this.selected = [];
      this.userData = {};
      this.selectedRole = "";
      this.updateEnabled = false;
      this.promise = null;
      this.pagerLabel = {};
      this.myUsername = sessionData.getValue("username"); // for delete validation ( user cannot delete himself)
      this.myId = sessionData.getValue("userId"); // for updating user role (=adminId)
      this.userRoles = [
        userRolesEnum.CONSUMER,
        userRolesEnum.SYSTEM_ADMIN,
        userRolesEnum.MERCHANT_ADMIN,
        userRolesEnum.COMPANY_ADMIN,
        userRolesEnum.FACILITY_ADMIN
      ]; // get all user roles from userRolesEnum
      this.filterUsers = "";

      // Grid data
      this.pageOptions = [5, 10, 15];
      this.orderBy = "";
      this.order = "";

      // add new user model
      this.email = "";
      this.firstName = "";
      this.lastName = "";
      this.verified = false;

      init.call(this);
    }

    AccountManagementViewModel.prototype.destroy = function () {};

    AccountManagementViewModel.prototype.refresh = function (usersDataJson) {
      this.data = usersDataJson;
      this.totalElements = usersDataJson.totalElements;
    };

    AccountManagementViewModel.prototype.paginationChanged = function (
      page,
      limit
    ) {
      this.currentPage = page;
      this.limitPerPage = limit;
    };

    return AccountManagementViewModel;

    function init() {
      var gridSettings = gridUtils.getDefaultGridSettings();
      this.limitPerPage = gridSettings.limitPerPage;
      this.currentPage = gridSettings.page;

      // hide label on small screens (tested on iphone6) because table pagination isnt responsive
      if ($mdMedia("sm") || $mdMedia("xs")) {
        this.pagerLabel = {
          page: "",
          rowsPerPage: "",
          of: ""
        };
      } else {
        this.pagerLabel = gridSettings.translations;
      }
    }
  }
})();
